import { type ClassValue, clsx } from "clsx";

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

/**
 * Format large numbers with M (million) and T (trillion) suffixes
 * @param value - The number to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted string like "$99.96M" or "$1.23T"
 */
export function formatLargeNumber(value: number, decimals: number = 2): string {
  if (value === 0) return "0";

  const absValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  if (absValue >= 1_000_000_000_000) {
    // Trillions
    return `${sign}${(absValue / 1_000_000_000_000).toFixed(decimals)}T`;
  } else if (absValue >= 1_000_000_000) {
    // Billions
    return `${sign}${(absValue / 1_000_000_000).toFixed(decimals)}B`;
  } else if (absValue >= 1_000_000) {
    // Millions
    return `${sign}${(absValue / 1_000_000).toFixed(decimals)}M`;
  } else if (absValue >= 1_000) {
    // Thousands
    return `${sign}${(absValue / 1_000).toFixed(decimals)}K`;
  } else {
    return value.toFixed(decimals);
  }
}

/**
 * Format currency with large number abbreviations
 * @param value - The number to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted string like "$99.96M" or "$1.23T"
 */
export function formatCurrencyLarge(
  value: number,
  decimals: number = 2
): string {
  return `$${formatLargeNumber(value, decimals)}`;
}
